import React, { useState, useEffect } from "react";
import getUsersByCondominio from "../../../../API/server/getusers";
import deleteUser from "../../../../API/Manager/deletarUser";

import "../../../../styles/desktop/deletar.css";

export default function Deletar({ onBack }) {
    const [showBackButton, setShowBackButton] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [users, setUsers] = useState([]); // Estado para armazenar os dados dos usuários

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowBackButton(true);
        }, 500); // Meio segundo (500ms)

        return () => clearTimeout(timer); // Limpa o timeout caso o componente seja desmontado
    }, []);

    // Chamada à API para buscar os usuários
    useEffect(() => {
        setUsers([]); // Reseta a lista antes de buscar novos dados
        setErrorMessage(""); // Reseta a mensagem de erro
        try {
            getUsersByCondominio().then((data) => {
                if (data && data.users) {
                    setUsers(data.users); // Define os usuários no estado
                    console.log(data.users);
                } else {
                    setErrorMessage("Nenhum dado recebido da API.");
                    console.warn("Nenhum dado recebido da API.");
                }
            });
        } catch (error) {
            setErrorMessage("Erro ao carregar usuários. Verifique a conexão com o servidor.");
            console.error("Erro ao carregar usuários:", error);
        }
    }, []);

    const handleBackButtonClick = () => {
        setShowBackButton(false);
        setTimeout(() => onBack(), 300);
    };

    const handleDelete = async (id, user) => {
        const confirmDelete = window.confirm(`Tem certeza que deseja deletar o usuário com ID ${id}?`);
        const userSession = JSON.parse(sessionStorage.getItem("user"));
        if (!confirmDelete) return;
        if(id === userSession.id || user === userSession.user) {    
            setErrorMessage("Você não pode deletar o usuário logado, entre em contato com o suporte.");
            return;
        }
        try {
            // Chama a função de deletar o usuário
            await deleteUser(id, user);
    
            // Atualiza a lista de usuários após deletar
            const updatedUsers = users.filter((u) => u.id !== id);
            setUsers(updatedUsers);
            
            setSuccessMessage("Usuário deletado com sucesso.");  
        } catch (error) {
            console.error("Erro ao deletar usuário:", error);
            setErrorMessage("Erro ao deletar usuário. Tente novamente mais tarde.");
        }
    };

    return (
        <div className="deletarContent">
            <div className="adicionar-header">
                <h1 className="adicionar-title">Deletar usuário</h1>
            </div>
            {successMessage && <div className="successMessage-delete">{successMessage}</div>}
            {errorMessage && <div className="errorMessage-delete">{errorMessage}</div>}
            <div className="tableBorder">
                <div className="tableContent">
                    <table>
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Nome</th>
                                <th>Usuário</th>
                                <th>Email</th>
                                <th>Condomínio</th>
                                <th>Permissões</th>
                                <th>Função</th>
                                <th>Criado em</th>
                                <th>Deletar</th>
                            </tr>
                        </thead>
                        <tbody>
                            {users.length > 0 ? (
                                users.map((user) => (
                                    <tr key={user.id}>
                                        <td>{user.id}</td>
                                        <td>{user.name}</td>
                                        <td>{user.user}</td>
                                        <td>{user.email}</td>
                                        <td>{user.condominio}</td>
                                        <td>
                                            {Object.entries(user.report)
                                                .filter(([key, value]) => value)
                                                .map(([key]) => key)
                                                .join(", ") || "Nenhuma"}
                                        </td>
                                        <td>{user.role}</td>
                                        <td>{new Date(user.created_at).toLocaleString()}</td>
                                        <td>
                                            <button
                                                className="deleteButton"
                                                onClick={() => handleDelete(user.id, user.user)}
                                            >
                                                Deletar
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="9">Nenhum usuário encontrado.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            {showBackButton && (
                <div className="deletar-back-button fade-in" onClick={handleBackButtonClick}>
                    Voltar
                </div>
            )}
        </div>
    );
}
